import { Component, OnInit } from '@angular/core';
import { ICampaign } from '../../store/models/campaigns.model';
import { CampaignService } from '../../store/services/campaign.service';
import { ISelectItem } from '../../store/models/select.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IContactGroup } from '../../store/models/contact.model';
import { ContactsService } from '../../store/services/contacts.service';

@Component({
  selector: 'app-sent-to-campign-dialog',
  templateUrl: './sent-to-campign-dialog.component.html',
  styleUrls: ['./sent-to-campign-dialog.component.scss'],
})
export class SentToCampignDialogComponent implements OnInit {

  campaigns: ICampaign[];
  campaignGroups: IContactGroup[] = [];

  inputForm: FormGroup;

  componentReady: boolean;

  readonly startDate: Date | null = new Date();

  constructor(
    private readonly campaignService: CampaignService,
    private readonly contactsService: ContactsService,
  ) {
  }

  get campaignItems(): ISelectItem[] {
    return this.campaigns.map(c => ({ label: c.campaign_name, value: c.campaign_id }));
  }

  get groups(): ISelectItem[] {
    return this.campaignGroups.map(g => ({ label: g.group_name, value: g.group_id }));
  }

  get group_id(): number {
    return this.inputForm.get('group_id').value;
  }

  ngOnInit(): void {
    this.campaignService.getActiveCampaigns()
      .subscribe(activeCampaigns => {
        this.campaigns = activeCampaigns.items;

        this.inputForm.addControl('campaign_id', new FormControl('', [Validators.required]));
        this.inputForm.addControl('group_id', new FormControl('', [Validators.required]));
        this.inputForm.addControl('start_date', new FormControl('', [Validators.required]));

        this.componentReady = true;
      });
  }

  onCampaignSelect($event: any) {
    if (!$event) {
      return;
    }

    this.contactsService.getContactGroupsByCampaignId($event)
      .subscribe(contactGroups => {
        this.campaignGroups = contactGroups.items;
      });
  }
}
